module.exports = __webpack_public_path__ + "static/img/defaultService_100x100_@3x.e76e246.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/defaultService_100x100_@3x.png
// module id = 38nq
// module chunks = 1